import { useCallback, useRef } from 'react';
import { isNotEmpty } from '@dealstack/shared/lib/isNotEmpty.ts';
import { HIGHLIGHTED_CLASS_NAME } from '@dealstack/frontend/shared/components/DocumentViewerV2/PdfViewer/pdf-constants';

export const useSmartFieldsNavigation = () => {
	const documentViewRef = useRef<HTMLDivElement>(null);
	const smartFieldsWrapperRef = useRef<HTMLDivElement>(null);

	const removeHighlightFromAll = useCallback(() => {
		const highlightedElements = documentViewRef.current?.querySelectorAll(
			`input[class="${HIGHLIGHTED_CLASS_NAME}"]`
		);
		if (isNotEmpty(highlightedElements)) {
			highlightedElements.forEach((el) => el.classList.remove(HIGHLIGHTED_CLASS_NAME));
		}
	}, [documentViewRef.current]);

	const onSmartFieldClick = useCallback(
		(fieldKey: string) => {
			removeHighlightFromAll();

			const pdfInput = documentViewRef.current?.querySelector(`input[name="${fieldKey}"]`);
			if (!pdfInput) {
				return;
			}

			pdfInput.classList.add(HIGHLIGHTED_CLASS_NAME);
			pdfInput.scrollIntoView({ behavior: 'smooth' });
		},
		[documentViewRef.current]
	);

	const onDocumentClick = (e) => {
		removeHighlightFromAll();

		const pdfInputKey = e.target?.name;
		if (!pdfInputKey) {
			return;
		}

		const smartField = smartFieldsWrapperRef.current?.querySelector(`div[id="${pdfInputKey}"]`);
		if (!smartField) {
			return;
		}

		smartField.scrollIntoView({ behavior: 'smooth' });
		smartField.classList.add(HIGHLIGHTED_CLASS_NAME);

		setTimeout(() => {
			smartField.classList.remove(HIGHLIGHTED_CLASS_NAME);
		}, 1000);
	};

	return {
		documentViewRef,
		smartFieldsWrapperRef,
		onSmartFieldClick,
		onDocumentClick,
	};
};
